const FEATURE_FLAG_COMPONENTS = [
  {homepage_purchaseHistory: false}
];

export const isFeatureFlag = (component) => FEATURE_FLAG_COMPONENTS[component];
